import React, { useContext, useEffect, useState } from "react";
import { matchPath, Redirect, useLocation } from "react-router";
import { AssetCard } from "@10x/dubai-rest-api/dist/property_registry/entity";
import { EjariContext } from "@eres/ejari-core/contexts/EjariContext";
import { SpinnerLoader } from "@my-dld/components/SpinnerLoader";
import { useSelector } from "react-redux";
import { IStore } from "@my-dld/reducers/store";
import EjariApi from "@eres/ejari-api";
import { getEjariPropertyTypeFromTabu } from "@eres/ejari-api/Utils";
import { dispatch } from "@my-dld/utils/StoreUtils";
import { showMessage } from "@my-dld/utils/UIUtils";
import { EjariDataAction } from "@eres/ejari-core/reducers/EjariData";
import { GetMobilePropertyDetailsResponse } from "@eres/ejari-api/EjariSecurityUtil";

type PageState = "loading" | "done" | "error" | "invalid";

interface PropertyLoaderProps {
}

export type  EjariCtxPropertyLoader = React.ElementType<PropertyLoaderProps>;
const FORCE_REFRESH_TIME = 2;
const TabuPropertyLoader: React.FunctionComponent<PropertyLoaderProps> = props => {
	const location = useLocation();
	const ctx = useContext( EjariContext );
	const match: any = matchPath( location.pathname, {
		path: "/mydld/property/:propertyTypeId/:propertyId/ejarisvc",
		exact: false,
		strict: false
	} );
	let type = match ? Number( match.params.propertyTypeId ) : 0;
	let id = match ? Number( match.params.propertyId ) : 0;
	let tabuProperty = useSelector<IStore, AssetCard | undefined>( state => {
		return state.UserData.properties?.find( ( p: AssetCard ) => {
			return p.propertyId === id && p.propertyTypeId === type;
		} );
	} );

	const [ status, setStatus ] = useState<PageState>( ( tabuProperty == null ? "invalid" : "loading" ) );
	let jp = JSON.stringify( ctx.property );
	let jl = JSON.stringify( ctx.tabuLink );
	useEffect( () => {
		if ( tabuProperty ) {
			let ctxProp = ctx.property;
			let tabuLink = ctx.tabuLink;
			let lastPropertyTime = ctx.lastPropertyTime || 0;
			let timeDiff = ( new Date().getTime() - lastPropertyTime ) / ( 1000 * 60 );
			if ( ctxProp && tabuLink &&
				tabuLink.isFreeHold + "" === ( tabuProperty.isFreeHold || tabuProperty.isLeaseHold ) + "" &&
				tabuLink.propertyId === tabuProperty.tabuPropertyId &&
				tabuLink.propertyType === tabuProperty.propertyTypeId &&
				timeDiff < FORCE_REFRESH_TIME
			) {
				setStatus( "done" );
			} else {
				EjariApi.getPropertyDetail( tabuProperty.tabuPropertyId + "", tabuProperty.isFreeHold || tabuProperty.isLeaseHold, getEjariPropertyTypeFromTabu( tabuProperty.propertyTypeId ) )
				.then( p => {
					dispatch( EjariDataAction.EJARI_UPDATE_STATE, {
						lastPropertyTime: new Date().getTime(),
						property: p,
						tabuProperty: tabuProperty,
						tabuLink: {
							isFreeHold: tabuProperty?.isFreeHold || tabuProperty?.isLeaseHold,
							propertyId: tabuProperty?.tabuPropertyId,
							propertyType: tabuProperty?.propertyTypeId,
						}
					} );
					setStatus( "done" );
				} ).catch( showMessage );
			}
		}
		return () => {

		};
	}, [ tabuProperty, jp, jl ] );
	if ( status === "loading" )
		return <div style={ { width: "100%", display: "flex", minHeight: 200, alignItems: "center" } }>
			<SpinnerLoader/>
		</div>;
	if ( status === "invalid" )
		return <Redirect to={ "/mydld" }/>;
	return <React.Fragment>{ props.children }</React.Fragment>;
};

const EjariPropertyLoader: React.FunctionComponent<PropertyLoaderProps> = props => {
	const location = useLocation();
	const ctx = useContext( EjariContext );
	const match: any = matchPath( location.pathname, {
		path: "/mydld/leased/property/:propertyTypeId/:propertyId/:isFreeHold/:isWallet/ejarisvc",
		exact: false,
		strict: false
	} );
	let typeId = match ? Number( match.params.propertyTypeId ) : undefined;
	let id = match ? match.params.propertyId : undefined;
	let isFreeHold = match ? ( match.params.isFreeHold === "true" ) : undefined;
	const [ status, setStatus ] = useState<PageState>( "loading" );
	let jp = JSON.stringify( ctx.property );
	useEffect( () => {
		let ctxProp = ctx.property;
		let tabuLink = ctx.tabuLink;
		let lastPropertyTime = ctx.lastPropertyTime || 0;
		let timeDiff = ( new Date().getTime() - lastPropertyTime ) / ( 1000 * 60 );
		if ( ctxProp && tabuLink &&
			tabuLink.isFreeHold + "" === isFreeHold + "" &&
			tabuLink.propertyId === id &&
			tabuLink.propertyType === typeId &&
			timeDiff < FORCE_REFRESH_TIME
		) {
			setStatus( "done" );
		} else {
			EjariApi.getPropertyDetailsSecure( "" + id! ).then( p => {
				dispatch( EjariDataAction.EJARI_UPDATE_STATE, {
					lastPropertyTime: new Date().getTime(),
					property: p,
					tabuLink: {
						isFreeHold: isFreeHold,
						propertyId: id,
						propertyType: typeId,
					}
				} );
				setStatus( "done" );
			} ).catch( showMessage );
		}
	}, [ jp ] );
	if ( typeId == undefined || id == undefined || isFreeHold == undefined )
		return <Redirect to={ "/mydld" }/>;
	if ( status === "loading" )
		return <div style={ { width: "100%", display: "flex", minHeight: 200, alignItems: "center" } }>
			<SpinnerLoader/>
		</div>;
	return <React.Fragment>{ props.children }</React.Fragment>;
};

const DefaultPropertyLoader: React.FunctionComponent<PropertyLoaderProps> = props => {
	return <React.Fragment>{ props.children }</React.Fragment>;
};

export default DefaultPropertyLoader;
export { TabuPropertyLoader, EjariPropertyLoader };
